import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomButton from "../../../../components/common/CustomButton";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import ReactSelect from "react-select";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import {
  GetDataEruByICDCodes,
  GetEruDetails,
  ImportEru,
  addOrUpdateERUs,
} from "../../../../api/User/ACG/ERUsApi";
import theme from "../../../../Utils/theme";
import { DownloadCensusErrorFile } from "../../../../api/User/ACG/ImportCensusApi";
import SelectAsyncPaginate from "../../../../components/Pagination/SelectAsyncPaginate";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  CodeType: Yup.string()
    .notOneOf(["Select Code Type"], "Invalid value")
    .required("Please select Code Type"),
  RxCode: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter ICD10 Code/Rx Code"),
  RxDescription: Yup.string()
    .typeError("Please enter a value")
    .required("Please enter ICD10/Rx Description"),
  MEDCMRXMGType: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter MEDC/MRXMG Type"),
  Prognosis: Yup.string()
    .typeError("Please enter a value")
    .required("Please enter Prognosis"),
  EDCDescription: Yup.string()
    .typeError("Please enter a value")
    .required("Please enter EDC Description"),
  EDCCode: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter EDC Code"),
  OccurAverage: Yup.string()
    .notOneOf(["Likely to Occur Average"], "Invalid value")
    .required("Please select Likely"),
  ERU1: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU1"),
  ERU2: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU2"),
  ERU3: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU3"),
  ERU4: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU4"),
  ERU5: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU5"),
  ERU6: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU6"),
  ERU7: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU7"),
  ERU8: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU8"),
  ERU9: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU9"),
  ERU10: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU10"),
  ERU11: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU11"),
  ERU12: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ERU12"),
  LatentEru: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter latent Eru"),
  RiskScoreVeryLow: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter risk score very low"),
  RiskScoreLow: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter risk score low"),
  RiskScoreModerate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter risk score moderate"),
  RiskScoreHigh: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter risk score high"),
  RiskScoreVeryHigh: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter risk score very high"),
  RiskScoreAverage: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter risk score average"),
  UnscaledTotalPRI: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter unscaled total PRI"),
  RUBVeryLow: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB very low"),
  RUBLow: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB low"),
  RUBModerate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB moderate"),
  RUBHigh: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB high"),
  RUBVeryHigh: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB very high"),
  RUBAverage: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB average"),
  AMSRUB1: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter AMS RUB 1"),
  AMSRUB2: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter AMS RUB 2"),
  AMSRUB3: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter AMS RUB 3"),
  AMSRUB4: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter AMS RUB 4"),
  AMSRUB5: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter AMS RUB 5"),
  AMSAverage: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter AMS Average"),
});

const ERUs = () => {
  // const [dropdownData, setDropdownData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [message, setMessage] = useState({ isModal: false, file: "" });
  const [isEdit, setIsEdit] = useState(false);
  const [rxCode, setRxCode] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isGetData, setIsGetData] = useState(true);
  const [importedFile, setImportedFile] = useState(null);
  const fileInputRef = useRef(null);
  const customStyles = {
    control: (base) => ({
      ...Fontstyling.primaryparagraph,
      display: "flex",
      alignItems: "center",
      border: "1px solid grey",
      width: "330px",
      maxHeight: "35px",
      height: "35px",
      textAlign: "left",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        ...Fontstyling.primaryparagraph,
        textAlign: "left",
      };
    },
  };

  useEffect(() => {
    const importedFileName = importedFile?.name;
    const importedFileFormat = importedFileName?.substring(
      importedFileName.lastIndexOf(".") + 1
    );

    if (importedFile) {
      if (importedFileFormat !== "csv") {
        toastFile("invalid file");
        setImportedFile(null);
        return;
      }

      const formData = new FormData();
      formData.append("files", importedFile);
      ImportEru(formData)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success) {
              toastFile("imported");
              //getData();
            } else {
              if (res.data.message === "failed") {
                setMessage((prev) => ({
                  file: res.data.file,
                  isModal: true,
                }));
              } else {
                toastFile(res.data.message);
              }
            }
          }
          setImportedFile(null);
        })
        .catch((err) => {
          console.log({ err });
        });
    }
  }, [importedFile]);

  // useEffect(() => {
  //   //getData();
  // }, []);

  useEffect(() => {
    if (rxCode !== null) {
      GetDataByICDCodes(rxCode?.icD10_Code);
    }
  }, [rxCode]);

  const GetDataByICDCodes = async () => {
    await GetDataEruByICDCodes(rxCode.icD10_Code)
      .then((res) => {
        if (res.status === 200) {
          setSelectedData(res.data);
          setShowForm(true);
          setIsEdit(true);
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // const getData = () => {
  //   setIsLoadOption(true);
  //   GetEruDetails()
  //     .then((res) => {
  //       if (res.status === 200) {
  //         let formatedData = res.data.map((obj) => {
  //           return { value: obj.ICD10_Code, label: obj.ICD10_Code };
  //         });
  //         setDropdownData(formatedData);
  //       }
  //     })
  //     .catch((err) => console.log({ err }))
  //     .finally((res) => setIsLoadOption(false));
  // };

  const handleActions = async (values) => {
    setWitchAction("");
    const {
      CodeType,
      RxCode,
      RxDescription,
      MEDCMRXMGType,
      MEDCMRXMG,
      ADG,
      Prognosis,
      MedicalChroniCondition,
      EDCDescription,
      EDCCode,
      OccurAverage,
      ERU1,
      ERU2,
      ERU3,
      ERU4,
      ERU5,
      ERU6,
      ERU7,
      ERU8,
      ERU9,
      ERU10,
      ERU11,
      ERU12,
      LatentEru,
      RiskScoreVeryLow,
      RiskScoreLow,
      RiskScoreModerate,
      RiskScoreHigh,
      RiskScoreVeryHigh,
      RiskScoreAverage,
      UnscaledTotalPRI,
      RUBVeryLow,
      RUBLow,
      RUBModerate,
      RUBHigh,
      RUBVeryHigh,
      RUBAverage,
      AMSDescription,
      AMSFlag,
      AMSRUB1,
      AMSRUB2,
      AMSRUB3,
      AMSRUB4,
      AMSRUB5,
      AMSAverage,
    } = values;
    const payload = {
      id: 0,
      code_Type: CodeType,
      icD10_Code: RxCode,
      icD10_Description: RxDescription,
      medC_TYPE: MEDCMRXMGType,
      medc: MEDCMRXMG,
      edc: EDCDescription,
      adg: ADG,
      prognosis: Prognosis,
      risk_Score: +RiskScoreAverage,
      risk_Pct: 0,
      erU1: +ERU1,
      erU2: +ERU2,
      erU3: +ERU3,
      erU4: +ERU4,
      erU5: +ERU5,
      erU6: +ERU6,
      erU7: +ERU7,
      erU8: +ERU8,
      erU9: +ERU9,
      erU10: +ERU10,
      erU11: +ERU11,
      erU12: +ERU12,
      latent_ERU: +LatentEru,
      medical_Chronic_Condition: MedicalChroniCondition,
      rx_MG_Code: "",
      rx_MG_Impact: "",
      major_Rx_MG_Description: "",
      diabetes_Rx_Indicator: "",
      cardiovascular_Rx_Indicator: "",
      mhsA_Rx_Indicator: "",
      cancer_Rx_Indicator: "",
      rS_RUB1: +RiskScoreVeryLow,
      rS_RUB2: +RiskScoreLow,
      rS_RUB3: +RiskScoreModerate,
      rS_RUB4: +RiskScoreHigh,
      rS_RUB5: +RiskScoreVeryHigh,
      rS_Avg: +RiskScoreAverage,
      ruB1: +RUBVeryLow,
      ruB2: +RUBLow,
      ruB3: +RUBModerate,
      ruB4: +RUBHigh,
      ruB5: +RUBVeryHigh,
      ruB_Avg: +RUBAverage,
      ams_description: AMSDescription,
      ams_rub_1_pri_spend: +AMSRUB1,
      ams_rub_2_pri_spend: +AMSRUB2,
      ams_rub_3_pri_spend: +AMSRUB3,
      ams_rub_4_pri_spend: +AMSRUB4,
      ams_rub_5_pri_spend: +AMSRUB5,
      edC_Code: EDCCode,
      recur: OccurAverage,
      ams_rub_avg_pri_spend: +AMSAverage,
      ams_flag: AMSFlag,
      unscaled_toal_pri: +UnscaledTotalPRI,
    };
    if (witchAction === "add") {
      setIsGetData(false);
      await addOrUpdateERUs(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          if (res.data === "Already Exists") {
            toastFile("Already Exists");
          } else {
            toastFile("new");
          }
          setShowForm(false);
          setWitchAction("");
          //setIsEdit(true);
          setIsGetData(true);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowForm(false);
          setWitchAction("");
        }
      });
      //getData();
    } else if (witchAction === "update") {
      await addOrUpdateERUs({
        ...payload,
        id: selectedData.id,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          toastFile("update");
          setWitchAction("");
          setIsEdit(true);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setWitchAction("");
          setIsEdit(true);
        }
      });
      //getData();
    }
  };
  return (
    <div>
      <Modal
        show={message.isModal}
        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            Below records could not be imported. Please check following possible
            issues:
          </div>
          <ol>
            <li>Zip_Code is not in 5-digits format.</li>
            <li>Number columns is blank.</li>
            <li>
              Number columns are populated with something other than numbers.
            </li>
          </ol>
          <div className="mt-3">
            Please click the link below to down load the error list:
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(message.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = message.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setMessage((prev) => ({ isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="d-md-flex d-block align-items-center justify-content-between py-3 border-bottom mb-3">
        <div className="d-flex gap-3">
          {isGetData && (
            <SelectAsyncPaginate
              value={rxCode}
              setRxCode={setRxCode}
              customStyles={customStyles}
              setShowForm={setShowForm}
              setWitchAction={setWitchAction}
            />
          )}
          {/* <CustomButton className={'m-0'}>Search</CustomButton>
                    <CustomButton className="px-3 fw-bold text-nowrap d-flex align-items-center">
                        <SaveAltIcon className="me-2" />
                        Export to CSV
                    </CustomButton> */}
        </div>
        <div className="d-flex align-items-center mt-md-0 mt-3 gap-3">
          <a
            href="https://ahiportal.azurewebsites.net/samplefile/ERU_Import_Template.csv"
            style={{
              textDecoration: "none",
            }}
            onMouseOver={(e) => {
              e.target.style.textDecoration = "underline";
            }}
            onMouseOut={(e) => {
              e.target.style.textDecoration = "none";
            }}
            download
          >
            Download Template
          </a>

          <CustomButton
            className={"m-0"}
            onClick={() => {
              fileInputRef.current.click();
            }}
          >
            Import ERU
          </CustomButton>
          <input
            type="file"
            ref={fileInputRef}
            onChange={(event) => {
              setImportedFile(event.target.files[0]);
              event.target.value = "";
            }}
            style={{ display: "none" }}
          />

          {witchAction === "" ? (
            <>
              {isEdit && (
                <CustomButton
                  style={{
                    ...Fontstyling.addnewbutton,
                    background: theme.SECONDARY_CHEERFUL_GOLD,
                  }}
                  onClick={() => {
                    setWitchAction("update");
                    setIsEdit(false);
                  }}
                >
                  Edit
                </CustomButton>
              )}
              <CustomButton
                onClick={async () => {
                  setShowForm(false);
                  await setSelectedData(null);
                  await setRxCode(null);
                  await setWitchAction("add");
                  await setIsEdit(false);
                  setShowForm(true);
                }}
              >
                Add New
              </CustomButton>
            </>
          ) : (
            <>
              <button type="submit" form="form" style={Fontstyling.savebutton}>
                Save
              </button>
              <button
                style={Fontstyling.cancelbutton}
                onClick={() => {
                  setShowForm(false);
                  setTimeout(() => {
                    if (witchAction === "update") setShowForm(true);
                  }, 100);
                  if (rxCode !== null) setIsEdit(true);
                  setWitchAction("");
                }}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
      {showForm && (
        <Formik
          validationSchema={schema}
          onSubmit={handleActions}
          initialValues={{
            CodeType: selectedData
              ? selectedData.code_Type
              : "Select Code Type",
            RxCode: selectedData ? selectedData.icD10_Code : "",
            RxDescription: selectedData ? selectedData.icD10_Description : "",
            MEDCMRXMGType: selectedData ? selectedData.medC_TYPE : "",
            MEDCMRXMG: selectedData ? selectedData.medc : "",
            ADG: selectedData ? selectedData.adg : "",
            Prognosis: selectedData ? selectedData.prognosis : "",
            MedicalChroniCondition: selectedData
              ? selectedData.medical_Chronic_Condition
              : "",
            EDCDescription: selectedData ? selectedData.edc : "",
            EDCCode: selectedData ? selectedData.edC_Code : "",
            OccurAverage: selectedData
              ? selectedData.recur
              : "Likely to Occur Average",
            AMSDescription: selectedData ? selectedData.ams_description : "",
            AMSFlag: selectedData ? selectedData.ams_flag : "",
            ERU1: selectedData ? selectedData.erU1 : "0",
            ERU2: selectedData ? selectedData.erU2 : "0",
            ERU3: selectedData ? selectedData.erU3 : "0",
            ERU4: selectedData ? selectedData.erU4 : "0",
            ERU5: selectedData ? selectedData.erU5 : "0",
            ERU6: selectedData ? selectedData.erU6 : "0",
            ERU7: selectedData ? selectedData.erU7 : "0",
            ERU8: selectedData ? selectedData.erU8 : "0",
            ERU9: selectedData ? selectedData.erU9 : "0",
            ERU10: selectedData ? selectedData.erU10 : "0",
            ERU11: selectedData ? selectedData.erU11 : "0",
            ERU12: selectedData ? selectedData.erU12 : "0",
            LatentEru: selectedData ? selectedData.latent_ERU : "0",
            RiskScoreVeryLow: selectedData ? selectedData.rS_RUB1 : "0",
            RiskScoreLow: selectedData ? selectedData.rS_RUB2 : "0",
            RiskScoreModerate: selectedData ? selectedData.rS_RUB3 : "0",
            RiskScoreHigh: selectedData ? selectedData.rS_RUB4 : "0",
            RiskScoreVeryHigh: selectedData ? selectedData.rS_RUB5 : "0",
            RiskScoreAverage: selectedData ? selectedData.rS_Avg : "0",
            UnscaledTotalPRI: selectedData
              ? selectedData.unscaled_toal_pri
              : "0",
            RUBVeryLow: selectedData ? selectedData.ruB1 : "0",
            RUBLow: selectedData ? selectedData.ruB2 : "0",
            RUBModerate: selectedData ? selectedData.ruB3 : "0",
            RUBHigh: selectedData ? selectedData.ruB4 : "0",
            RUBVeryHigh: selectedData ? selectedData.ruB5 : "0",
            RUBAverage: selectedData ? selectedData.ruB_Avg : "0",
            AMSRUB1: selectedData ? selectedData.ams_rub_1_pri_spend : "0",
            AMSRUB2: selectedData ? selectedData.ams_rub_2_pri_spend : "0",
            AMSRUB3: selectedData ? selectedData.ams_rub_3_pri_spend : "0",
            AMSRUB4: selectedData ? selectedData.ams_rub_4_pri_spend : "0",
            AMSRUB5: selectedData ? selectedData.ams_rub_5_pri_spend : "0",
            AMSAverage: selectedData ? selectedData.ams_rub_avg_pri_spend : "0",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form id="form" onSubmit={handleSubmit}>
              <Row className="mb-2 gap-3">
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Code Type
                      <Required />
                    </Form.Label>
                    <Form.Select
                      className="rounded-0"
                      style={Fontstyling.label}
                      name="CodeType"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={
                        values.CodeType === "Select Code Type" &&
                        touched.CodeType
                      }
                    >
                      <option value={"Select Code Type"}>
                        --Select Code Type--
                      </option>
                      {["Med", "Rx"].map((item, index) => (
                        <option
                          value={item}
                          selected={values.CodeType === item}
                        >
                          {item}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please select code type
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      ICD10 Code/Rx Code
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="RxCode"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.RxCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode}
                      isInvalid={touched.RxCode && errors.RxCode}
                      placeholder="ICD10 Code"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.RxCode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      ICD10/Rx Description
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="RxDescription"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.RxDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={touched.RxDescription && errors.RxDescription}
                      type="text"
                      placeholder="ICD10 Description"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.RxDescription}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      MEDC/MRXMG Type
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="MEDCMRXMGType"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.MEDCMRXMGType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={touched.MEDCMRXMGType && errors.MEDCMRXMGType}
                      type="text"
                      placeholder="MEDC Type"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.MEDCMRXMGType}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-2 gap-3">
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      MEDC/MRXMG
                    </Form.Label>
                    <Form.Control
                      name="MEDCMRXMG"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.MEDCMRXMG}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={touched.MEDCMRXMG && errors.MEDCMRXMG}
                      type="text"
                      placeholder="MEDC"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.MEDCMRXMG}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      ADG
                    </Form.Label>
                    <Form.Control
                      name="ADG"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.ADG}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={touched.ADG && errors.ADG}
                      type="text"
                      placeholder="ADG"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.ADG}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Prognosis
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="Prognosis"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.Prognosis}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={touched.Prognosis && errors.Prognosis}
                      type="text"
                      placeholder="Prognosis"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.Prognosis}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Medical Chronic Condition
                    </Form.Label>
                    <Form.Control
                      name="MedicalChroniCondition"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.MedicalChroniCondition}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={
                        touched.MedicalChroniCondition &&
                        errors.MedicalChroniCondition
                      }
                      type="text"
                      placeholder="Medical Chronic Condition"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.MedicalChroniCondition}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-2 gap-3">
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      EDC Description
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="EDCDescription"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.EDCDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={
                        touched.EDCDescription && errors.EDCDescription
                      }
                      type="text"
                      placeholder="EDC Description"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.EDCDescription}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      EDC Code
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="EDCCode"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.EDCCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={touched.EDCCode && errors.EDCCode}
                      placeholder="EDC Code"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.EDCCode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Likely to Occur Average
                      <Required />
                    </Form.Label>
                    <Form.Select
                      className="rounded-0"
                      style={Fontstyling.label}
                      name="OccurAverage"
                      value={values.OccurAverage.trim()[0]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={
                        values.OccurAverage === "Likely to Occur Average" &&
                        touched.OccurAverage
                      }
                    >
                      <option value={"Likely to Occur Average"}>
                        --Likely to Occur Average--
                      </option>
                      {[
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                      ].map((item, index) => (
                        <option
                          value={item.value}
                          // selected={values.OccurAverage === item}
                        >
                          {item.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please select Likely to Occur Average
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <div className="mt-3 text-start" style={Fontstyling.heading}>
                ERU Detail:
              </div>
              <Row className="mb-2 gap-3">
                {["ERU1", "ERU2", "ERU3", "ERU4"].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item}
                      value={values}
                      maxLength={10}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
              <Row className="mb-2 gap-3">
                {["ERU5", "ERU6", "ERU7", "ERU8"].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item}
                      value={values}
                      maxLength={10}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
              <Row className="mb-2 gap-3">
                {["ERU9", "ERU10", "ERU11", "ERU12"].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item}
                      value={values}
                      maxLength={10}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
              <Row>
                <Col>
                  <CustomInputField
                    label={"LatentEru"}
                    name={"LatentEru"}
                    value={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    maxLength={10}
                    touched={touched}
                    errors={errors}
                    disabled={rxCode && isEdit}
                    isRequired
                  />
                </Col>
              </Row>
              <div className="mt-3 text-start" style={Fontstyling.heading}>
                Risk Score Detail:
              </div>
              <Row className="mb-2 gap-3">
                {[
                  "Risk Score Very Low",
                  "Risk Score Low",
                  "Risk Score Moderate",
                  "Risk Score High",
                ].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item.split(" ").join("")}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      maxLength={10}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
              <Row className="mb-2 gap-3">
                {[
                  "Risk Score Very High",
                  "Risk Score Average",
                  "Unscaled Total PRI",
                ].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item.split(" ").join("")}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      maxLength={10}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
              <div className="mt-3 text-start" style={Fontstyling.heading}>
                RUB Detail:
              </div>
              <Row className="mb-2 gap-3">
                {["RUB Very Low", "RUB Low", "RUB Moderate", "RUB High"].map(
                  (item, index) => (
                    <Col>
                      <CustomInputField
                        key={index}
                        label={item}
                        name={item.split(" ").join("")}
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={10}
                        disabled={rxCode && isEdit}
                        isRequired
                      />
                    </Col>
                  )
                )}
              </Row>
              <Row className="mb-2 gap-3">
                {["RUB Very High", "RUB Average"].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item.split(" ").join("")}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      maxLength={10}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
              <div className="mt-3 text-start" style={Fontstyling.heading}>
                AMS Detail:
              </div>
              <Row className="mb-2 gap-3">
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      AMS Description
                    </Form.Label>
                    <Form.Control
                      name="AMSDescription"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.AMSDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={
                        touched.AMSDescription && errors.AMSDescription
                      }
                      type="text"
                      placeholder="AMS Description"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.AMSDescription}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      AMS Flag
                    </Form.Label>
                    <Form.Select
                      className="rounded-0"
                      style={Fontstyling.label}
                      name="AMSFlag"
                      value={values.AMSFlag.trim()[0]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={rxCode && isEdit}
                      isInvalid={
                        values.AMSFlag === "Select AMS Flag" && touched.AMSFlag
                      }
                    >
                      <option value={"Select AMS Flag"}>
                        --Select AMS Flag--
                      </option>
                      {[
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                      ].map((item, index) => (
                        <option
                          value={item.value}
                          // selected={values.AMSFlag === item.value}
                        >
                          {item.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please select AMS Flag
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-2 gap-3">
                {["AMS RUB 1", "AMS RUB 2", "AMS RUB 3", "AMS RUB 4"].map(
                  (item, index) => (
                    <Col>
                      <CustomInputField
                        key={index}
                        label={item}
                        name={item.split(" ").join("")}
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={10}
                        disabled={rxCode && isEdit}
                        isRequired
                      />
                    </Col>
                  )
                )}
              </Row>
              <Row className="gap-3 pb-5 border-bottom">
                {["AMS RUB 5", "AMS Average"].map((item, index) => (
                  <Col>
                    <CustomInputField
                      key={index}
                      label={item}
                      name={item.split(" ").join("")}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      maxLength={10}
                      disabled={rxCode && isEdit}
                      isRequired
                    />
                  </Col>
                ))}
              </Row>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default ERUs;
